export const transactionTypes = {
    buy: 'buy',
    sell: 'sell'
}